var React = require('react');

function ButtonArrowsIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17.5072 10.5244L9.5369 20.6129H14.0001L22.0007 10.5244L13.8004 0.500488H9.37955L9.35938 0.522678L17.5072 10.5244Z","fill":"white","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.67521 10.5244L0.704866 20.6129H5.16811L13.1687 10.5244L4.9684 0.500488H0.547517L0.527344 0.522678L8.67521 10.5244Z","fill":"white","key":1})]);
}

ButtonArrowsIcon.defaultProps = {"width":"22","height":"21","viewBox":"0 0 22 21","fill":"none"};

module.exports = ButtonArrowsIcon;

ButtonArrowsIcon.default = ButtonArrowsIcon;
